import src from "IMAGE";
export default { src, width: 333, height: 394, blurWidth: 0, blurHeight: 0};
